export default function CatalogWholesaleStrip({
  enabled,
  dealer,
  accentColor,
  onLoginClick,
  onOpenOrders,
  onLogout,
}) {
  if (!enabled) return null;

  const dealerName = String(dealer?.name || "").trim();
  const accent = String(accentColor || "").trim() || "#fbbf24";

  return (
    <section
      className={
        dealer
          ? "catalog-wholesale-strip catalog-wholesale-strip--active"
          : "catalog-wholesale-strip"
      }
      dir="rtl"
      aria-label="تجار الجملة"
      style={{ "--wholesale-strip-accent": accent }}
    >
      <div className="container catalog-wholesale-strip__inner">
        {dealer ? (
          <p className="catalog-wholesale-strip__text">
            <strong>{dealerName || "تاجر الجملة"}</strong>
            <span className="catalog-wholesale-strip__sep" aria-hidden>
              ·
            </span>
            <span>تتسوّق الآن بأسعار الجملة المعتمدة لهذا المتجر</span>
          </p>
        ) : (
          <p className="catalog-wholesale-strip__text">
            <strong>تاجر جملة</strong>
            <span className="catalog-wholesale-strip__sep" aria-hidden>
              ·
            </span>
            <span>
              لديك حساب معتمد؟ سجّل الدخول بالبريد وكلمة المرور لعرض أسعار الجملة وإرسال
              الطلبات
            </span>
          </p>
        )}

        <div className="catalog-wholesale-strip__actions">
          {dealer ? (
            <>
              <button
                type="button"
                className="catalog-wholesale-strip__btn catalog-wholesale-strip__btn--primary"
                onClick={onOpenOrders}
              >
                طلباتي
              </button>
              <button
                type="button"
                className="catalog-wholesale-strip__btn"
                onClick={onLogout}
              >
                خروج
              </button>
            </>
          ) : (
            <button
              type="button"
              className="catalog-wholesale-strip__btn catalog-wholesale-strip__btn--primary"
              onClick={onLoginClick}
            >
              دخول تاجر جملة
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
